import { useQuery } from "react-query";
import { PetService } from "../../services/PetsService";
import { namesUseQuery } from "../../utils/constants";
import { useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";

export function useAllPets() {
  const { db } = useContext(CurrentUserContext);

  const { data, isLoading } = useQuery(
    [namesUseQuery?.ALL_PETS],
    () => PetService.getAllPets(db),
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return {
    data: data,
    isLoading,
  };
}
